import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { formatTime } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Video = observer(class Video extends React.Component {
  constructor() {
    super();
    this.togglePlay = this.togglePlay.bind(this);
    this.toggleMute = this.toggleMute.bind(this);
    this.updatePlaybar = this.updatePlaybar.bind(this);
  }

  componentWillMount() {
    this.state = {
      currentTime: 0,
      playing: false,
      volume: 100,
      muted: false,
      duration: 100,
      ready: false,
      unsupported: false
    }
  }

  videoDelay = null;

  componentDidMount() {
    const _this = this;
    let delayCount = 0;

    // Wait until video is ready and then get the duration
    _this.videoDelay = setInterval(function(){
      delayCount++;

      if(_this.video && _this.video.readyState > 0) {
        _this.setState({
          duration: _this.video.duration,
          ready: true
        });

        clearInterval(_this.videoDelay);
      } else if(delayCount >= 100) {
        // If we’ve tried setting the video enough times,
        // we can assume it’s still being converted
        _this.setState({
          unsupported: true
        });

        clearInterval(_this.videoDelay);
      }
    }, 100);
  }

  componentDidUpdate() {
    clearInterval(this.timer);

    if(this.state.playing) {
      this.timer = setInterval(this.updatePlaybar, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.videoDelay);
    clearInterval(this.timer);
  }

  togglePlay() {
    if(this.state.playing) {
      this.video.pause();
    } else {
      this.video.play();
    }

    this.setState({
      playing: !this.state.playing
    });
  }

  toggleMute() {
    if(this.state.muted) {
      this.video.muted = false;
    } else {
      this.video.muted = true;
    }

    this.setState({
      muted: !this.state.muted
    });
  }

  updatePlaybar() {
    this.setState({
      currentTime: this.video.currentTime
    });
  }

  track(e) {
    const multiplier = this.progress.value / 100;

    // Set the current time to the total time multiplied by the percent
    const newTime = multiplier * this.state.duration;

    // Update the video’s current time
    this.video.currentTime = newTime;

    // Update the state
    this.setState({
      currentTime: newTime
    });
  }

  render() {
    const { translation } = this.props;

    return (
      <article className="video">
        {/* If video is not supported or still converting, show message */}
        {this.state.unsupported &&
          <span className="text-block">{translation.not_supported}</span>
        }

        {/* Show video when it’s ready */}
        {!this.state.unsupported &&
          <video
            className={this.state.playing ? 'playing' : ''}
            src={this.props.src}
            autoPlay={this.props.autoplay}
            ref={el => this.video = el}
          >
            <strong>{translation.not_supported}</strong>
          </video>
        }

        {/* Show controls if video is ready and they’re enabled */}
        {this.state.ready && this.props.controls &&
          <div className="video__controls">
            <button
              className="video__btn video__play btn--reset"
              onClick={this.togglePlay}
            >
              {this.state.playing ? <icons.iconPause /> : <icons.iconPlay />}

              <span className="meta">
                {this.state.playing ? translation.pause : translation.play}
              </span>
            </button>

            <input
              type="range"
              className="video__progress"
              defaultValue={this.state.currentTime / this.state.duration * 100}
              onChange={e => this.track(e)}
              ref={input => this.progress = input}
              min="0"
              max="100"
              step="1"
            />

            <span className="video__time">
              {formatTime(this.state.currentTime)} / {formatTime(this.state.duration)}
            </span>

            <button
              className={`video__btn video__mute btn--reset ${this.state.muted ? 'muted' : ''}`}
              onClick={this.toggleMute}
            >
              <icons.iconVolumeUp />

              <span className="meta">
                {this.state.muted ? translation.unmute : translation.mute}
              </span>
            </button>
          </div>
        }
      </article>
    );
  }
})

export default translate('Video')(Video);



// WEBPACK FOOTER //
// ./src/app/components/Modules/Video.js